export default {
  filters:{
    /**
     * 
     * かなに含まれるA-Z , a-z , ★ 除外して表示する
     * Remove any instances of A-Z, a-z, and ★ from the string
     * 
     * Examples:
     * K★にいのうあいこ ⇒ にいのうあいこ
     * HKみなみかん ⇒ みなみかん
     * xくにみまさおみ ⇒ くにみまさおみ
     * 
     * @param {string} value 
     * @returns {string}
     */
    LetsMixin_stripSpecialCharacters(value) {
      return value.replace(/([A-Za-z★])/g, '');
    }
  },
  data(){
    return {
    }
  },
  methods: {

  },
  computed: {
    LetsVDatePickerProps (){
      return {
        firstDayOfWeek: 1,
        dayFormat: (date) => new Date(date).getDate(),
        noTitle: true,
      }
    }
  },
  mounted () {

  }
}
